<template>
  <div class="dashboard body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmEdit = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <el-row class="bg-White p-3">
          <el-col :lg="6">
            <h3 style="margin: 0">انشاء مرتجع</h3>
          </el-col>
          <el-col :lg="10"></el-col>
          <el-col :lg="3">
            <b>رقم الفاتوره : </b>
            <b>{{ purchases[0].id }}</b>
          </el-col>
          <el-col :lg="5">
            <b>اسم المورد : </b>
            <b v-if="supplier">{{ supplier.name }}</b>
          </el-col>
        </el-row>
        <el-table
          ref="returnInvoiceTable"
          :data="purchases[selectedIndex].products"
          align="right"
          style="overflow: auto"
          border
        >
          <el-table-column align="right" width="100">
            <template slot="header">
              <el-checkbox
                id="selectAll"
                @change="checkedAllProducts"
                ref="checkAll"
                ><small>تحديد الكل</small></el-checkbox
              >
            </template>
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                @change="selectProduct(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="#" type="index"></el-table-column>
          <el-table-column label="المنتج" prop="name"></el-table-column>
          <el-table-column label="الوحدة" prop="pivot.unit"></el-table-column>
          <el-table-column label="الكمية">
            <template slot-scope="scope">
              {{ scope.row.pivot.qty - scope.row.pivot.returned_qty }}
            </template>
          </el-table-column>
          <el-table-column label="اضافة كمية المرتجع">
            <template slot-scope="scope">
              <el-popover
                :ref="scope.row.id + '-' + scope.row.pivot.unit_type"
                placement="left"
                trigger="manual"
                content="لا يمكن ادخال كمية زياده عن ما تم شراءه"
                v-model="scope.row.showQtyToolTip"
                class="bg-danger"
                style="
                  background-color: #f56c6c !important;
                  color: #fff !important;
                "
              >
              </el-popover>
              <input
                type="number"
                class="form-control"
                @change="calcTotal(scope.row)"
                min="0"
                :class="scope.row.showQtyToolTip ? 'error' : ''"
                @focus="$event.target.select()"
                v-model="scope.row.pivot.return_qty"
                v-popover="scope.row.id + '-' + scope.row.pivot.unit_type"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="سعر الشراء"
            prop="pivot.buy_cost"
          ></el-table-column>
          <el-table-column label="الإجمالي">
            <template slot-scope="scope">
              {{ scope.row.pivot.buy_cost * scope.row.pivot.return_qty }}
            </template>
          </el-table-column>
        </el-table>
        <el-row
          :gutter="10"
          class="footer"
          v-if="purchases[selectedIndex].products.length > 0"
        >
          <el-col :xl="6" :lg="6" :md="8" :sm="8">
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="bg-White alignment px-3 mt-2">
                  <p>الكميه</p>
                  <p>
                    <span class="num">{{ purchases[0].total_qty }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bg-White alignment px-3 mt-2">
                  <p>كمية المرتجع</p>
                  <p>
                    <span class="num">{{ reternSale.total_qty }}</span>
                  </p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="8">
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="bg-White alignment px-3 mt-2">
                  <p>اجمالي الفاتورة</p>
                  <p>
                    <span class="num">{{
                      purchases[0].total_sale_cost -
                      purchases[0].returned_amount
                    }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bg-White alignment px-3 mt-2">
                  <label>قيمة الخصم</label>
                  <input
                    class="form-control"
                    type="number"
                    @change="discountChange"
                    @focus="$event.target.select()"
                    v-model="purchases[0].discount"
                    placeholder="قيمه الخصم"
                    align="middle"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="8">
            <el-row :gutter="10">
              <el-col :span="11">
                <div class="bg-White alignment px-3 mt-2">
                  <p>قيمة المرتجع</p>
                  <p>
                    <span class="num">{{ reternSale.total_cost }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="13">
                <div class="bg-White alignment px-3 mt-2">
                  <p>
                    <small>الإجمالي بعد المرتجع</small>
                  </p>
                  <p>
                    <span class="num">{{
                      numberToFixed(purchases[0].total_sale_cost -
                      purchases[0].returned_amount -
                      this.purchases[0].discount -
                      (reternSale.total_cost - reternSale.discount))
                    }}</span>
                  </p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="12">
            <div class="bg-White alignment mt-2">
              <el-row>
                <el-popconfirm
                  v-if="purchases[0].discount > 0"
                  confirm-button-text="تاكيد"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  :title="
                    'سيتم خصم قيمة ' + purchases[0].discount + ' من الفاتورة'
                  "
                  @confirm="confirmEdit = true"
                >
                  <el-button class="save" slot="reference"
                    >حفظ المرتجع</el-button
                  >
                </el-popconfirm>
                <el-button v-else class="save" @click="confirmEdit = true"
                  >حفظ المرتجع</el-button
                >
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد الرجوع للتقرير؟"
                  @confirm="goTo('/purchases/return')"
                >
                  <el-button slot="reference" class="exit mr-3"
                    >الغاء</el-button
                  >
                </el-popconfirm>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div v-if="confirmEdit == true" class="dialog">
      <div class="bodySec">
        <p @click="confirmEdit = false">
          <span><i class="far fa-times-circle"></i></span> اغلاق
        </p>
      </div>
      <div class="content">
        <div class="headerSection">
          <p>الرصيد السابق</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                Number(purchases[selectedIndex].supplier.balance) +
                  Number(purchases[selectedIndex].supplier.account)
              )
            }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>اجمالي الفاتوره</p>
          <p class="mr-auto">
            {{ numberToFixed(Number(reternSale.total_cost) - Number(purchases[0].discount)) }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>اجمالي المدونية</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                Number(purchases[0].supplier.balance) -
                  (Number(reternSale.total_cost) - Number(purchases[0].discount))
              ) + numberToFixed(Number(purchases[0].supplier.account))
            }}
          </p>
        </div>
        <div class="mt-2">
          <el-radio-group
            v-model="setPaied"
            style="justify-content: start !important"
          >
            <el-radio-button label="without">حفظ بدون تحصيل</el-radio-button>
            <el-radio-button @click="alert" label="returnAmount"
              >تحصيل</el-radio-button
            >
          </el-radio-group>
        </div>
        <div v-if="setPaied == 'returnAmount'">
          <el-row>
            <el-col> <p class="label">قيمة المبلغ</p></el-col>
            <el-col>
              <input
                class="form-control"
                @focus="$event.target.select()"
                id="returnAmount"
                v-model="reternSale.returnAmount"
                @keyup.enter="editSale"
              />
            </el-col>
          </el-row>
        </div>
        <el-button
          class="mt-3 btn-green1 btn-save"
          @click="editSale"
          type="success"
          >حفظ الفاتورة</el-button
        >
        <el-button type="danger" @click="confirmEdit = false" class="exit mr-2"
          >الغاء</el-button
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  components: { Aside },
  name: "ReturnProducts",
  data: () => ({
    true: true,
    damaged_products: false,
    selectAll: false,
    checkselectAll: false,
    disabled: false,
    isLoading: false,
    false: false,
    supplier: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    buy_cost: "",
    min_price: "",
    qty: "",
    active: "edit_sales",
    confirmSave: false,
    confirmEdit: false,
    totalInvoice: 0,
    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: "-",
    value: "",
    num: 1,
    ind: 0,
    selectedPorductIndex: 0,
    setPaied: "without",
    activeDelete: false,
    useParcode: false,
    autoPush: true,
    selectedIndex: 0,
    showPrice: false,
    percentageDiscount: 0,
    selectedUnitId: null,
    allowDeletePayment: false,
    showQtyToolTip: false,
    purchases: [
      {
        inventory_id: 1,
        id: 0,
        purchase_id: "",
        paied: 0,
        returnAmount: 0,
        retuunt: 0,
        VAT: 0,
        supplier: null,
        damaged_products: false,
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        discount: 0,
        total_return_cost: 0,
        products: [],
        total_discount: 0,
      },
    ],
    reternSale: {
      inventory_id: 1,
      id: 0,
      purchase_id: "",
      paied: 0,
      returnAmount: 0,
      retuunt: 0,
      VAT: 0,
      supplier: null,
      damaged_products: false,
      total_cost: 0,
      total_buy_cost: 0,
      total_sale_cost: 0,
      total_qty: 0,
      discount: 0,
      total_return_cost: 0,
      products: [],
      total_discount: 0,
    },
  }),
  created() {
    if (localStorage.getItem("edited_purchases")) {
      let sale_data = localStorage.getItem("edited_purchases");
      this.purchases = JSON.parse(sale_data);
      this.supplier = this.purchases[0].supplier;
      this.calcTotal();
    } else {
      if (this.$route.params.id > 0) {
        this.getInvoice();
      }
    }
  },
  mounted() {
    // this.scrollToEnd();
  },
  watch: {
    setPaied: function (v) {
      this.reternSale.returnAmount = 0;
      if (v === "with") {
        setTimeout(() => {
          document.getElementById("paied").focus();
        }, 100);
      } else if (v === "returnAmount") {
        setTimeout(() => {
          document.getElementById("returnAmount").focus();
        }, 100);
      }
    },
  },
  methods: {
    alert() {
      alert("price clicked");
    },
    percentageDiscountChange() {
      this.reternSale.discount = Number(
        (Number(this.percentageDiscount) * Number(this.reternSale.total_cost)) /
          100
      ).toFixed(2);
    },
    discountChange() {
      this.percentageDiscount = Number(
        (Number(this.reternSale.discount) /
          Number(this.reternSale.total_cost)) *
          100
      ).toFixed(2);
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    getInvoice() {
      if (this.$route.params.id > 0) {
        axiosApi
          .get(`purchases/${this.$route.params.id}`)
          .then((response) => {
            if (response.data.length > 0) {
              this.purchases = response.data;
              this.supplier = response.data[0].supplier;
              this.purchases[0].total_sale_cost = this.purchases[0].total_cost;
              this.purchases[0].discount = response.data[0].discount;
              this.purchases[0].damaged_products = false;
              this.purchases[0].total_return_cost = 0;
              this.purchases[0].purchase_id = this.$route.params.id;
              this.discountChange();
              let qty = 0;
              this.purchases[0].products.map(function (value) {
                qty += value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                value["pivot"]["old_qty"] = value["pivot"]["qty"];
                value["pivot"]["return_qty"] = 0;
                value["showQtyToolTip"] = false;
                value["checked"] = false;
              });
              this.purchases[0].total_qty = qty;
              this.totalInvoice = this.purchases[
                this.selectedIndex
              ].total_sale_cost;
            }
            this.checkStock();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        console.log("من فضلك حدد رقم الفاتورة أولا للبحث");
      }
    },
    showPaymentModal() {
      this.confirmSave = true;
    },
    checkStock() {
      // edit-receipt/check-stock
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post(`edit-receipt/check-stock`, {
          products: this.purchases[this.selectedIndex].products,
        })
        .then((res) => {
          loading.close();
          console.log("edit-receipt/check-stock", res.data);
          this.purchases[this.selectedIndex].products = res.data;
          this.checkQty();
        })
        .catch(() => {
          loading.close();

          // this.$notify.error({
          //   title: "حدث خطأ",
          //   message: `عفوا المخزن المتاح لا يكفي `,
          //   duration: 1500,
          // });
        });
    },
    editSale() {
      if (!this.isLoading) {
        if (this.purchases[this.selectedIndex].products.length > 0) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل البيانات",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let products = [];
          for (let i = 0; i < this.purchases[0].products.length; i++) {
            if (this.purchases[0].products[i].pivot.return_qty > 0) {
              products.push({
                id: this.purchases[0].products[i].id,
                name: this.purchases[0].products[i].name,
                barcode: this.purchases[0].products[i].barcode,
                units_per_package: this.purchases[0].products[i]
                  .units_per_package,
                unit: this.purchases[0].products[i].pivot.unit,
                units: this.purchases[0].products[i].pivot.units,
                unit_type: this.purchases[0].products[i].pivot.unit_type,
                min_price: this.purchases[0].products[i].pivot.min_price,
                sale_price: this.purchases[0].products[i].pivot.sale_price
                  ? this.purchases[0].products[i].pivot.sale_price
                  : 1,
                buy_cost: this.purchases[0].products[i].pivot.buy_cost,
                lastSaleCost: this.purchases[0].products[i].pivot.lastSaleCost,
                old_qty: Number(this.purchases[0].products[i].pivot.qty),
                qty: Number(this.purchases[0].products[i].pivot.return_qty),
                showQtyToolTip: false,
                showPriceToolTip: false,
                inventory_id: JSON.parse(
                  localStorage.getItem("user_inventories")
                )[0].id,
              });
            }
          }

          this.reternSale = {
            ...this.reternSale,
            inventory_id: this.purchases[0].inventory_id,
            purchase_id: this.purchases[0].purchase_id,
            supplier: this.purchases[0].supplier,
            VAT: this.purchases[0].VAT,
            percentage_discount: this.percentageDiscount,
            total_discount: this.purchases[0].discount,
            products: [...products],
            discount: this.purchases[0].discount,
          };
          this.reternSale.products = [...products];
          axiosApi
            .post(`purchases/return`, this.reternSale)
            .then((response) => {
              this.invoice_details = response.data.invoice_details;
              localStorage.setItem(
                "sale_edited_invoice",
                JSON.stringify(response.data.invoice_details)
              );
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              setTimeout(() => {
                this.$router.push("/purchases/return");
              }, 100);
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من كمية المرتجع",
                  duration: 1500,
                });
                for (let i = 0; i < this.purchases[0].products.length; i++) {
                  this.purchases[0].products[i].pivot.qty =
                    err.response.data[0].products[i].pivot.qty;
                  this.purchases[0].products[i].pivot.returned_qty =
                    err.response.data[0].products[i].pivot.returned_qty;
                }
                this.confirmEdit = false;
              }
              console.log(err.response);
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      }
    },
    calcTotal() {
      this.reternSale.total_cost = 0;
      this.reternSale.total_qty = 0;
      for (var i = 0; i < this.purchases[0].products.length; i++) {
        if (
          Number(this.purchases[0].products[i].pivot.return_qty) >
          this.purchases[0].products[i].pivot.qty -
            this.purchases[0].products[i].pivot.returned_qty
        ) {
          this.purchases[0].products[i].showQtyToolTip = true;
        } else {
          this.purchases[0].products[i].showQtyToolTip = false;
        }

        if (Number(this.purchases[0].products[i].pivot.return_qty) > 0) {
          this.purchases[0].products[i].checked = true;
        } else {
          this.purchases[0].products[i].checked = false;
        }
        let returnTotal = Number(
          this.purchases[0].products[i].pivot.return_qty *
            this.purchases[0].products[i].pivot.buy_cost
        );
        this.reternSale.total_qty += Number(
          this.purchases[0].products[i].pivot.return_qty
        );
        this.reternSale.total_cost += Number(returnTotal);
      }
    },
    checkQty() {
      for (var i = 0; i < this.purchases[0].products.length; i++) {
        this.purchases[0].products[i].pivot.qty = Number(
          this.purchases[0].products[i].pivot.qty
        );
        let qty = 0;
        if (
          Number(this.purchases[0].products[i].pivot.qty) >=
          Number(this.purchases[0].products[i].pivot.old_qty)
        ) {
          qty =
            Number(this.purchases[0].products[i].pivot.qty) -
            Number(this.purchases[0].products[i].pivot.old_qty);
        }
        if (qty > Number(this.purchases[0].products[i].stock)) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (this.purchases[0].products[i].pivot.qty == "") {
          this.purchases[0].products[i].pivot.qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("return_purchases", JSON.stringify(this.purchases));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");
    },
    saveShortKey() {
      if (this.confirmEdit) {
        this.editSale();
      }
    },
    selectProduct(row) {
      if (row.pivot.return_qty < row.pivot.qty - row.pivot.returned_qty) {
        row.pivot.return_qty = row.pivot.qty - row.pivot.returned_qty;
        row.checked = true;
      } else {
        row.pivot.return_qty = 0;
        row.checked = false;
      }
      this.calcTotal();
    },
    selectAllProducts() {
      document.getElementById("selectAll").click();
    },
    checkedAllProducts() {
      this.selectAll = !this.selectAll;
      if (this.selectAll == true) {
        this.purchases[0].products.map((product) => {
          product.pivot.return_qty =
            product.pivot.qty - product.pivot.returned_qty;
        });
      } else {
        this.purchases[0].products.map((product) => {
          product.pivot.return_qty = 0;
        });
      }
      this.calcTotal();
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
.text-center {
  text-align: center !important;
}
.el-table {
  width: 100%;
  min-height: 77%;
  max-height: 77%;
  overflow-y: scroll;
}
.form-control {
  height: 40px !important;
}
.el-main .footer .bg-White {
  flex-direction: column;
}
.el-main .footer .bg-White p {
  margin: 0;
}
.el-radio-button__inner {
  width: 120px !important;
}
</style>
<style>
.el-popover--plain {
  padding: 11px 14px !important;
  background-color: #dc3545 !important;
  color: #fff !important;
}
</style>
